module.exports = __webpack_public_path__ + "img/ic_checkmark_green_large.e0c79d9b.png";